import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { ILectioPlugin } from './Types';

export class PluginMathJaxRequiredContentFix implements ILectioPlugin {
	public Init(): void {
		//STM 29667 - der er en fejl i mathjax pluginet - requiredContent skal sættes så vi f.eks. kan få disabled knappen i notefelten
		CKEDITOR.on('instanceReady', evt => {
			const c = evt.editor.getCommand('mathjax');
			if (c) {
				(c as any).requiredContent = 'span(lc-math-tex)';
			}
		});
	}
}
